
module.cC({
    name: 'CertificateViewController',
    inject: ['$scope', 'certificate', 'ModelService', '$state'],
    data: {'certificate': 'certificate'},

    methods: {
        deleteCertificate: function() {
            this.ModelService.deleteModel(this.certificate)
                .then(this.$state.go.bind(this.$state, '^.index'))
        }
    }
});
